import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorReferral1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M5.75 8a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm6.108 3.794a4.75 4.75 0 1 0-5.717 0A7.753 7.753 0 0 0 1.25 19v.5a.75.75 0 0 0 1.5 0V19a6.25 6.25 0 1 1 12.5 0v.5a.75.75 0 0 0 1.5 0V19a7.753 7.753 0 0 0-4.892-7.206Z"
    />
    <path
      fill="#F7A600"
      d="M15 3.25a.75.75 0 0 0 0 1.5 3.25 3.25 0 0 1 0 6.5.75.75 0 0 0 0 1.5A6.25 6.25 0 0 1 21.25 19v.5a.75.75 0 0 0 1.5 0V19a7.753 7.753 0 0 0-4.892-7.206A4.75 4.75 0 0 0 15 3.25Z"
    />
  </svg>
);
export default SvgTwoColorReferral1;
